<template>
	<div class="container">
		<div class="team_information">
			<input readonly="readonly" unselectable="on" οnfοcus="this.blur()" @focus="getFocus" ref="inputFocus" v-model="unit_name" type="" name="" id="" value="" placeholder="请输入单位名称" />
		</div>
		<div class="team_information">
			<input @focus="getFocus" ref="inputFocus" v-model="department" type="" name="" id="" value="" placeholder="部门（不必填）" />
		</div>
		<div class="team_information">
			<input @focus="getFocus" ref="inputFocus" v-model="name" type="" name="" id="" value="" placeholder="联系人姓名" />
		</div>
		<div class="team_information">
			<input @focus="getFocus" ref="inputFocus" v-model="phone" maxlength="11" type="" name="" id="" value="" placeholder="联系人手机号" />
		</div>
		<div v-if="appointmenttime=='预约日期'" class="team_information team_information_time" @click="information_time">
			{{appointmenttime}}
		</div>
		<div v-else="" class="team_information team_information_time" @click="information_time">
			{{appointmenttime}} {{site_name}}票
		</div>
		<div class="team_information">
			<input ref="inputFocus" v-model="people_num" type="number" name="" id="" value="" placeholder="总人数" />
		</div>
		<div class="inp_file">
			<div v-for="(item,index) in license" class="file">
				<div class="file_img">
					<img :src="item.fileurl" v-if="item.format=='png'||item.format=='gif'||item.format=='jpg'||item.format=='jpeg'" />
					<div v-if="item.format!='png'&&item.format!='gif'&&item.format!='jpg'&&item.format!='jpeg'">{{item.filename}}</div>
				</div>
				<div class="file_no" @click="Delete(item,index)">
					<img src="../assets/file_no.png" />
				</div>
			</div>
			<div class="file">
				<div class="file_img">
					<img src="../assets/file_two.png" />
				</div>
				<form id="uploadForm" enctype="multipart/form-data">
					<input id="upload2" accept="image/*" type="file" name="upload" multiple="multiple" v-on:change="uploadFile()" />
					<!--<button name="upload1" id="upload1" type="button" onclick="uploadFile()">upload</button>-->
				</form>
			</div>
		</div>
		<div class="fill_btn" @click="buttombc">
			立即预约
		</div>
		<div class="submission" v-show="submission">
			<div class="sub_text">
				<div v-if="test">您的团队预约已成功,<br>请携带介绍信及本人身份证取票入馆</div>
				<div v-if="!test">您的团队预约申请已提交,<br> 请耐心等待审核结果.</div>
				<div @click="Return">返回首页</div>
			</div>
		</div>
		<div class="yin_ts" v-if="yin">
			<div class="buttom_x">
				<img src="../assets/buttom_x.png" />
			</div>
			<div class="text">{{yin_text}}</div>
			<div class="buttom_text" @click="modify">去修改</div>
		</div>
		<div class='view_yinyin' v-if="yin" catchtouchmove="return" @click="modify"></div>

		<div v-show="getTime_black_show" class="getTime_black" @click="getTime_black">

		</div>
		<div v-show="getTime_show" class="getTime">
			<div class="appointment">
				<div>请选择预约门票时间</div>
			</div>
			<Calendar v-on:choseDay="clickDay"></Calendar>
			<div v-if="registrationEnd!=''" class="registrationEnd">
				{{registrationEnd}}
			</div>
			<ul v-else="" class="personal_site">
				<li v-if="item.ticketnums>0" :class="activeClass==index?'personal_site_red':'personal_site_white'" v-for="(item,index) in details" @click="changeli_site(item,index)">
					<div>{{item.name}}票</div>
					<div>(余票：<span>{{item.ticketnums}}</span>)</div>
				</li>
				<li v-else="" class="personal_site_white">
					<div>{{item.name}}票</div>
					<div>(已约满)</div>
				</li>
			</ul>
			<div class="personal_btn" @click="next_cli">下一步</div>
		</div>
		<div class="established" v-show="establishedShow">
			<div class="established_content">

				<div class="established_top_top">如实际到馆人数比预约人数少10人以上(含10人)，则团队不允许入馆，三次计入黑名单。疫情期间，参观当天请提供团队所有成员的纸质版姓名及身份证号，以作备案。<br>是否继续预约</div>
				<div class="established_bottom">
					<div @click="establishedYes">确认</div>
					<div @click="establishedNo">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	import Calendar from 'vue-calendar-component';
	export default {
		name: 'TeamReservation',
		data() {
			return {
				taid: "",
				unit_name: "",
				department: "",
				name: "",
				idNumber: "",
				time: "请选择预约时间",
				people_num: "",
				peisonal_documentType: "请选择证件类型",
				yin: false,
				yin_text: "",
				name_reg: "",
				IdNumber_reg: "",
				submission: false,
				fill_img: "",
				fill_img_two: "",
				Scene: "请选择场次",
				baseUrl: "",
				opentimecustomlist: [],
				license: [],
				phone: "",
				phoneReg: "",
				month: "",
				details: [],
				activeClass: -1,
				appointmenttime: "预约日期",
				getTime_show: false,
				getTime_black_show: false,
				site_name: "",
				paragraphid: "",
				registrationEnd: "",
				baseUrlOne: "",
				today: "",
				unit_reg: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				access_token: "",
				establishedShow: false,
				test: false,
				thisTime:""
			}
		},
		components: {
			Calendar
		},
		methods: {
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			getTime_black() {
				var that = this;
				that.getTime_show = false;
				that.getTime_black_show = false;
			},
			information_time() {
				var that = this;
				var mo = function(e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false)
				that.getTime_show = true;
				that.getTime_black_show = true;
			},
			clickDay(data) {
				var that = this;
				that.activeClass = -1;
				var today = new Date().getTime().toString().substring(0, 5);
				that.year = data.split("/")[0];
				that.month = data.split("/")[1];
				that.day = data.split("/")[2];
				if(that.month < 10) {
					that.month = "0" + that.month
				}
				if(that.day < 10) {
					that.day = "0" + that.day
				}
				var today_cli = that.year + "-" + that.month + "-" + that.day;
				console.log(new Date(that.today).getTime().toString(),new Date(today_cli).getTime().toString())
				if(new Date(that.today).getTime().toString() > new Date(today_cli).getTime().toString()) {
					that.registrationEnd = '门票预约已经结束';
				} else {
					for(var i = 0; i < that.opentimecustomlist.length; i++) {
						if(today_cli == that.opentimecustomlist[i].time) {
							that.details = that.opentimecustomlist[i].details;
							that.appointmenttime = that.opentimecustomlist[i].time;
							that.registrationEnd = "";
							if(that.opentimecustomlist[i].status == '0') {
								that.registrationEnd = '闭馆';
							}
							return;
						} else {
							 if(new Date(that.today).getTime().toString() == new Date(today_cli).getTime().toString()) {
								that.registrationEnd = '不可预约';
							}else{
								that.registrationEnd = '门票预约暂未开始';
							}
							
						}
					}
				}

			},
			changeli_site(item, index) {
				var that = this;
				that.activeClass = index;
				that.site_name = item.name;
				that.paragraphid = item.paragraphid;
				that.outtime=item.outtime;
			},
			next_cli() {
				var that = this;
				var timer=new Date();
				var hour=timer.getHours();
				var minutes=timer.getMinutes();
				var thisSecond=parseInt(hour)*60*60+parseInt(minutes)*60;
				var cliSecond=parseInt(that.outtime.split(':')[0])*60*60+parseInt(that.outtime.split(':')[1])*60;
				console.log(thisSecond)
				console.log(cliSecond)
				if(that.activeClass == -1) {
					that.yin = true;
					that.yin_text = '请选择预约时间';
				} else if(that.appointmenttime==that.today&&parseInt(thisSecond)>parseInt(cliSecond)) {
					that.yin = true;
					that.yin_text = '您所选日期不能预约，请重新选择！';
				} else {
					var mo = function(e) {
						e.preventDefault();
					};
					document.body.style.overflow = ''; //出现滚动条
					document.removeEventListener("touchmove", mo, false);
					that.getTime_show = false;
					that.getTime_black_show = false;
				}
			},
			buttombc() {
				var that = this;
				that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
				that.unit_reg = /^[\u4e00-\u9fa5a-zA-Z]{2,30}$/;
				that.IdNumber_reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				if(that.unit_name == "") {
					that.yin = true;
					that.yin_text = '请输入单位名称';
				} else if(!that.unit_reg.test(that.unit_name)) {
					that.yin = true;
					that.yin_text = '请输入正确的单位名称，只能包含字母汉字，2-30位';
				} else if(that.department != '' && !that.unit_reg.test(that.department)) {
					that.yin = true;
					that.yin_text = '请输入正确的部门名称';
				} else if(!that.name_reg.test(that.name)) {
					that.yin = true;
					that.yin_text = '姓名认证错误';
				} else if(!that.phoneReg.test(that.phone)) {
					that.yin = true;
					that.yin_text = '手机号认证错误';
				} else if(that.appointmenttime == "预约日期") {
					that.yin = true;
					that.yin_text = '请选择预约时间';
				} else if(that.people_num == "") {
					that.yin = true;
					that.yin_text = '请填写预约人数';
				} else if(that.people_num < 10) {
					that.yin = true;
					that.yin_text = '预约人数不足10人';
				} else if(that.people_num > 200) {
					that.yin = true;
					that.yin_text = '预约人数最多200人';
				} else if(that.license.length == 0) {
					that.yin = true;
					that.yin_text = '请上传介绍信';
				} else {
					that.establishedShow = true;
				}

			},
			modify() {
				var that = this;
				that.yin = false;
			},
			modify() {
				var that = this;
				that.yin = false;
			},
			Return() {
				var that = this;
				that.$router.push({
					name: 'Logo'
				});
			},
			uploadFile() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrl + '/account/upload/file/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.fileurl.length == 1) {
							if(that.license.length > 2) {
								that.yin = true;
								that.yin_text = '最多上传三个文件';
							} else {
								that.license.push({
									"fileid": data.fileurl[0].fileid,
									"fileurl": data.fileurl[0].fileurl,
									"filename": data.fileurl[0].filename,
									"format": data.fileurl[0].format
								});
							}
						} else {
							if(data.fileurl.length > 3) {
								that.yin = true;
								that.yin_text = '最多上传三个文件';
							} else {
								that.license = data.fileurl;
							}
						}
					} else {
						that.yin = true;
						that.yin_text = data.errmsg;
					}

				}).fail(function(res) {});

			},
			Delete(item, index) {
				var that = this;
				that.license.splice(index, 1)
			},
			Delete_two() {
				var that = this;
				that.fill_img_two = ""
			},
			uploadFile_two() {
				var that = this;
				wclient.view.showLoading();
				$.ajax({
					url: that.baseUrl + '/account/upload/file/uploads',
					type: 'POST',
					cache: false,
					data: new FormData($('#uploadForm_two')[0]),
					processData: false,
					contentType: false
				}).done(function(res) {
					var data = $.parseJSON(res);
					if(data.code == 'A00006') {
						wclient.view.showLoading();
						that.fill_img_two = data.imageurl[0].imageurl;
					} else {
						that.yin = true;
						that.yin_text = '请上传图片';
					}
				}).fail(function(res) {});
			},
			establishedYes() {
				var that = this;
				that.establishedShow = false;
				wclient.view.showLoading();
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "POST",
					url: that.baseUrlOne + "/tickets/tickets/ajax?ugi=bookingticketorder&action=noteaminfoBooking&moduleid=TICKETS",
					dataType: "json",
					async: true,
					data: {
						taid: that.taid,
						appointmenttime: that.appointmenttime,
						paragraphid: that.paragraphid,
						ticketnum: that.people_num,
						idcard: that.idNumber,
						phone: that.phone,
						contacts: that.name,
						depart: that.department,
						unit: that.unit_name,
						license: JSON.stringify(that.license),
						access_token: that.access_token
					},
					success: function(data) {
						if(data.code == 'A00006') {
							wclient.view.hideLoading();
							that.submission = true;
						}else if(data.code == 'A00001'){
							that.yin = true;
							that.yin_text = '系统繁忙，请稍后再试';
							wclient.view.hideLoading();
						} else {
							that.yin = true;
							that.yin_text = data.errmsg;
							wclient.view.hideLoading();
						}
					}
				});
			},
			establishedNo() {
				var that = this;
				that.establishedShow = false;
			}
		},
		mounted() {
			var that = this;
			that.access_token = window.localStorage.getItem('access_token')
			that.phoneReg = /^1[3456789]\d{9}$/;
			let time = new Date();
			that.month = time.getMonth() + 1;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
					var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
				that.test = false;
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org";
				var baseUrlOne = "http://tickets.xs.weapi.org";
				that.test = false;
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				var baseUrlOne = "https://www.xiangshan1949.cn";
				that.test = true;
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			that.ordertype = sessionStorage.getItem("orderType");
			that.unit_name = sessionStorage.getItem("RegistrantTeamname");
			that.name = sessionStorage.getItem("RegistrantName");
			that.phone = sessionStorage.getItem("RegistrantPhone");
			if(that.ordertype == '0') {
				var type = '个人'
			} else if(that.ordertype == '1') {
				var type = '团队'
			}
			that.$http({
				method: "get",
				url: that.baseUrlOne + '/tickets/tickets/ajax?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=2d74de112b1944ef863539496d4efe96&sponsorid=a0df565fe509435eba413105fc9a006c',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(res => {
				that.taid = res.data.activitylist[0].taid
				that.$http({
					method: "get",
					url: that.baseUrlOne + '/tickets/tickets/ajax?ugi=bookingticket&action=bookingTime&moduleid=TICKETS&taid=' + that.taid + '&type=' + type,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					that.opentimecustomlist = res.data.opentimecustomlist;
					var timer = new Date();
					var year = timer.getFullYear();
					var month = timer.getMonth() + 1;
					var day = timer.getDate();
					if(month < 10) {
						month = "0" + month
					}
					if(day < 10) {
						day = "0" + day
					}
					that.today = year + "-" + month + "-" + day;
				}).catch(res => {
					console.log('发送Ajax请求,请求失败', res);
				});
			}).catch(res => {
				console.log('发送Ajax请求,请求失败', res);
			});
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		height: 100vh;
		background: #eee !important;
	}
	
	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.team_information {
		width: 85%;
		margin: 10px auto 0;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 11px 27px 2px rgba(233, 233, 233, 0.4);
		border-radius: 10px;
		padding: 3%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.team_information>img {
		width: 4%;
		margin-right: 1%;
	}
	
	.team_information input {
		outline: none;
		border: none;
		font-size: 16px;
		width: 100%;
		padding-left: 10px;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
		font-weight: 600;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
		font-weight: 600;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
		font-weight: 600;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
		font-weight: 600;
	}
	
	.inp_file {
		width: 90%;
		margin-left: 5%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 10px;
	}
	
	.file {
		float: left;
		position: relative;
		width: 30%;
		height: 100px;
		margin-bottom: 10px;
		border-radius: 10px;
		margin-right: 3%;
	}
	
	.file:last-child {
		margin-right: 0;
	}
	
	.file_img {
		float: left;
		width: 100%;
		height: 100%;
	}
	
	.file input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	select {
		background: white !important;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border: none;
		outline: none;
		font-size: 16px;
		color: #B1B1B1;
		width: 95%;
		padding-left: 10px;
		font-size: 16px;
	}
	
	option {
		color: black;
	}
	
	.file_no {
		position: absolute;
		top: -8px;
		right: -8px;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		box-shadow: 0px 1px 7px 2px rgba(154, 154, 154, 0.2);
		color: #9A9A9A;
		background: rgb(252, 245, 247);
	}
	
	.fill_btn_bottom {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		z-index: 999;
	}
	
	.fill_btn {
		margin: 20px auto 20px;
		width: 65%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		border-radius: 40px;
		color: rgba(254, 254, 254, 1);
		line-height: 45px;
		text-align: center;
		font-size: 14px;
	}
	
	.submission {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}
	
	.sub_text {
		width: 64%;
		margin: 34vh auto 0;
		background: white;
		border-radius: 10px;
	}
	
	.sub_text div:nth-child(1) {
		text-align: center;
		width: 90%;
		padding: 25px 5%;
		font-weight: 400;
	}
	
	.sub_text div:nth-child(2) {
		text-align: center;
		width: 100%;
		font-weight: 400;
		line-height: 40px;
		border-top: 1px solid #CDCDCD;
		color: rgba(207, 18, 14, 1);
	}
	
	.view_yinyin {
		width: 100vh;
		height: 100vh;
		background: rgba(0, 0, 0, .3);
		position: fixed;
		top: 0;
		overflow: hidden;
		z-index: 12;
	}
	
	.yin_ts {
		position: fixed;
		top: 25%;
		background: #fff;
		z-index: 999;
		border-radius: 20px;
		width: 66%;
		left: 17%;
		text-align: center;
	}
	
	.buttom_x {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;
	}
	
	.buttom_x img {
		width: 60px;
	}
	
	.text {
		font-size: 18px;
		font-family: PingFangSC-Medium;
		font-weight: 600;
		color: rgba(55, 55, 55, 1);
		width: 80%;
		margin: 0 auto;
	}
	
	.title {
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
		font-size: 16px;
		line-height: 30px;
		border-bottom: 1px rgb(225, 225, 225) solid;
		padding-bottom: 10px;
	}
	
	.buttom_text {
		color: rgba(228, 4, 4, 1);
		line-height: 50px;
		font-size: 16px;
		font-weight: bold;
		border-top: 1px solid #eee;
		margin-top: 20px;
	}
	
	.team_information_time {
		display: flex;
		color: #B1B1B1;
		font-weight: bold;
		text-indent: 10px;
	}
	
	.getTime_black {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}
	
	.getTime {
		width: 90%;
		padding: 0 5% 25px;
		background: rgba(246, 246, 246, 1);
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 11;
	}
	
	>>>.wh_container {
		width: 100%;
		border-radius: 50px;
	}
	
	>>>.wh_jiantou1 {
		border-top: 2px solid rgba(70, 70, 70, 1) !important;
		border-left: 2px solid rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_jiantou2 {
		border-top: 2px solid rgba(70, 70, 70, 1) !important;
		border-left: 2px solid rgba(70, 70, 70, 1) !important;
		transform: rotate(130deg) !important;
	}
	
	>>>.wh_top_changge li {
		color: rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_content_all {
		background: white !important;
	}
	
	>>>.wh_content_item {
		color: rgba(70, 70, 70, 1) !important;
	}
	
	>>>.wh_content_item .wh_chose_day {
		background: rgba(222, 75, 67, 1) !important;
		color: white !important;
	}
	
	>>>.wh_item_date {
		background: white !important;
	}
	
	.appointment {
		width: 100%;
		display: flex;
		justify-content: space-between;
		line-height: 50px;
		color: rgba(70, 70, 70, 1);
	}
	
	.personal_time {
		border-radius: 15px;
		float: left;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: white;
	}
	
	.personal_time img {
		width: 10px;
	}
	
	.registrationEnd {
		width: 100%;
		line-height: 72px;
		text-align: center;
		margin-top: 30px;
	}
	
	.personal_site {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}
	
	.personal_site_white {
		float: left;
		width: 47%;
		height: 62px;
		background: url(../assets/site_white.png) center center no-repeat;
		background-size: contain;
		padding-top: 10px;
		color: #ACB2B6;
	}
	
	.personal_site_red {
		float: left;
		width: 47%;
		height: 62px;
		background: url(../assets/site_red.png) center center no-repeat;
		background-size: contain;
		padding-top: 10px;
		color: #E40404;
	}
	
	.personal_site>li div {
		width: 100%;
		float: left;
		text-align: center;
		line-height: 20px;
	}
	
	.personal_site>li div:nth-child(1) {
		font-size: 14px;
		margin-top: 5px;
		font-weight: 500;
	}
	
	.personal_site>li div:nth-child(2) {
		font-size: 12px;
	}
	
	.personal_btn {
		width: 70%;
		margin: 50px auto 0;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		color: rgba(254, 254, 254, 1);
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		border-radius: 40px;
	}
	
	.established {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.established_content {
		width: 66%;
		background: white;
		border-radius: 10px;
	}
	
	.established_top {
		width: 100%;
		text-align: center;
		line-height: 50px;
		font-size: 18px;
	}
	
	.established_top_top {
		width: 90%;
		text-align: center;
		line-height: 25px;
		font-size: 15px;
		margin-bottom: 20px;
		margin: 20px auto;
		color: black;
	}
	
	.established_bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #b1b1b1;
	}
	
	.established_bottom div {
		width: 50%;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
	}
	
	.established_bottom div:nth-child(1) {
		border-right: 1px solid #b1b1b1;
	}
	/*安卓上传图片*/
	
	.filePhoto {
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.filePhoto_content {
		position: absolute;
		width: 100%;
		bottom: 0;
		left: 0;
	}
	
	.filePhoto_content div {
		width: 100%;
		background: white;
		border-top: 1px solid #b1b1b1;
		text-align: center;
		line-height: 50px;
		font-size: 16px;
		position: relative;
	}
	
	.filePhoto_content input {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0px;
		top: 0px;
		opacity: 0;
		-ms-filter: 'alpha(opacity=0)';
	}
	
	.distpicker-address-wrapper {
		width: 90%;
		display: flex;
		justify-content: space-between;
		margin: 10px auto 0;
	}
	
	.distpicker-address-wrapper>>>select {
		width: 33%;
		color: #B1B1B1;
		font-weight: 600;
		outline: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/teamReservation.vue